export default __webpack_public_path__ + "static/media/supplements.6a971d5d.jpg";